<template>
    <div class="bg-login-color">
        <div class="center-layout">
            <b-row class="card p-5">
                <b-col md="12" class="text-center">
                    <h3>Sorry, the page you are looking for is currently not available</h3>
                    <b-button v-if="$store.getters['account/accountData'].role === 'Transportation'" to="vehicle" class="mt-4"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back To Vehicle Dashboard</b-button>
                    <b-button v-else to="/" class="mt-4"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back To Dashboard</b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        goBack () {
            window.goBack(this)
        }
    },
}
</script>